/*
Copyright (C) Anheuser-Busch InBev SA/NV. ALL RIGHTS RESERVED.

This software product is a proprietary product of Anheuser-Busch Inbev SA/NV (the "Company") and all right, title, and interest in and to the software product, including all associated intellectual property rights, are and shall remain exclusively with the Company. All rights in or to the software product are licensed, not sold. All rights not licensed are reserved.

This software product is governed by the End User License Agreement provided with the software product.

*/
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/display.js
var e = {
	log: "log",
	debug: "debug",
	info: "info",
	warn: "warn",
	error: "error"
}, t = console, n = {};
Object.keys(e).forEach(function(e) {
	n[e] = t[e];
});
var r = "Datadog Browser SDK:", i = {
	debug: n.debug.bind(t, r),
	log: n.log.bind(t, r),
	info: n.info.bind(t, r),
	warn: n.warn.bind(t, r),
	error: n.error.bind(t, r)
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
function a(e, t) {
	return function() {
		var n = [...arguments];
		try {
			return e.apply(void 0, n);
		} catch (e) {
			i.error(t, e);
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var o;
(function(e) {
	e.PAGEHIDE = "pagehide", e.FEATURE_FLAGS = "feature_flags", e.RESOURCE_PAGE_STATES = "resource_page_states", e.COLLECT_FLUSH_REASON = "collect_flush_reason", e.ZERO_LCP_TELEMETRY = "zero_lcp_telemetry", e.DISABLE_REPLAY_INLINE_CSS = "disable_replay_inline_css", e.WRITABLE_RESOURCE_GRAPHQL = "writable_resource_graphql", e.CUSTOM_VITALS = "custom_vitals", e.TOLERANT_RESOURCE_TIMINGS = "tolerant_resource_timings";
})(o ||= {});
var s = /* @__PURE__ */ new Set();
function c(e) {
	e.forEach(function(e) {
		s.add(e);
	});
}
function l(e) {
	return s.has(e);
}
function u() {
	return s;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
function d(e) {
	return e !== 0 && Math.random() * 100 <= e;
}
function f(e) {
	return p(e) && e >= 0 && e <= 100;
}
function p(e) {
	return typeof e == "number";
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var m = 1e3, h = 60 * m, ee = 60 * h;
24 * ee * 365;
function g() {
	return (/* @__PURE__ */ new Date()).getTime();
}
function _() {
	return g();
}
function te() {
	return performance.now();
}
function v() {
	return {
		relative: te(),
		timeStamp: _()
	};
}
function ne() {
	return {
		relative: 0,
		timeStamp: se()
	};
}
function re(e, t) {
	return t - e;
}
function ie(e, t) {
	return e + t;
}
function ae(e) {
	return e - se();
}
var oe;
function se() {
	return oe === void 0 && (oe = performance.timing.navigationStart), oe;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var y = 1024, ce = 1024 * y, le = /[^\u0000-\u007F]/;
function ue(e) {
	return le.test(e) ? window.TextEncoder === void 0 ? new Blob([e]).size : new TextEncoder().encode(e).length : e.length;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
function b(e, t) {
	return e.indexOf(t) !== -1;
}
function de(e) {
	if (Array.from) return Array.from(e);
	var t = [];
	if (e instanceof Set) e.forEach(function(e) {
		return t.push(e);
	});
	else for (var n = 0; n < e.length; n++) t.push(e[n]);
	return t;
}
function fe(e, t) {
	for (var n = 0; n < e.length; n += 1) {
		var r = e[n];
		if (t(r, n)) return r;
	}
}
function x(e) {
	return Object.keys(e).map(function(t) {
		return e[t];
	});
}
function pe(e) {
	return Object.keys(e).map(function(t) {
		return [t, e[t]];
	});
}
function me(e, t) {
	return e.slice(0, t.length) === t;
}
function he(e, t) {
	return e.slice(-t.length) === t;
}
function S(e) {
	return [...arguments].slice(1).forEach(function(t) {
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	}), e;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
function ge(e) {
	return S({}, e);
}
function _e(e, t) {
	return Object.keys(e).some(function(n) {
		return e[n] === t;
	});
}
function ve(e) {
	return Object.keys(e).length === 0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
function C() {
	if (typeof globalThis == "object") return globalThis;
	Object.defineProperty(Object.prototype, "_dd_temp_", {
		get: function() {
			return this;
		},
		configurable: !0
	});
	var e = _dd_temp_;
	return delete Object.prototype._dd_temp_, typeof e != "object" && (e = typeof self == "object" ? self : typeof window == "object" ? window : {}), e;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
function w(e, t) {
	var n = C(), r;
	return n.Zone && typeof n.Zone.__symbol__ == "function" && (r = e[n.Zone.__symbol__(t)]), r ||= e[t], r;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/monitor.js
var ye = function(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}, be, xe = !1;
function Se(e) {
	be = e;
}
function Ce(e) {
	xe = e;
}
function we(e, t, n) {
	var r = n.value;
	n.value = function() {
		var e = [...arguments];
		return (be ? T(r) : r).apply(this, e);
	};
}
function T(e) {
	return function() {
		return E(e, this, arguments);
	};
}
function E(e, t, n) {
	try {
		return e.apply(t, n);
	} catch (e) {
		if (Te(e), be) try {
			be(e);
		} catch (e) {
			Te(e);
		}
	}
}
function Te() {
	var e = [...arguments];
	xe && i.error.apply(i, ye(["[MONITOR]"], e, !1));
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/timer.js
function D(e, t) {
	return w(C(), "setTimeout")(T(e), t);
}
function Ee(e) {
	w(C(), "clearTimeout")(e);
}
function De(e, t) {
	return w(C(), "setInterval")(T(e), t);
}
function Oe(e) {
	w(C(), "clearInterval")(e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/observable.js
var O = function() {
	function e(e) {
		this.onFirstSubscribe = e, this.observers = [];
	}
	return e.prototype.subscribe = function(e) {
		var t = this;
		return !this.observers.length && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0), this.observers.push(e), { unsubscribe: function() {
			t.observers = t.observers.filter(function(t) {
				return e !== t;
			}), !t.observers.length && t.onLastUnsubscribe && t.onLastUnsubscribe();
		} };
	}, e.prototype.notify = function(e) {
		this.observers.forEach(function(t) {
			return t(e);
		});
	}, e;
}();
function ke() {
	var e = [...arguments];
	return new O(function(t) {
		var n = e.map(function(e) {
			return e.subscribe(function(e) {
				return t.notify(e);
			});
		});
		return function() {
			return n.forEach(function(e) {
				return e.unsubscribe();
			});
		};
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
function Ae(e, t, n) {
	var r = n && n.leading !== void 0 ? n.leading : !0, i = n && n.trailing !== void 0 ? n.trailing : !0, a = !1, o, s;
	return {
		throttled: function() {
			var n = [...arguments];
			if (a) {
				o = n;
				return;
			}
			r ? e.apply(void 0, n) : o = n, a = !0, s = D(function() {
				i && o && e.apply(void 0, o), a = !1, o = void 0;
			}, t);
		},
		cancel: function() {
			Ee(s), a = !1, o = void 0;
		}
	};
}
function k() {}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
function A(e) {
	return e ? (parseInt(e, 10) ^ Math.random() * 16 >> parseInt(e, 10) / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, A);
}
var je = /([\w-]+)\s*=\s*([^;]+)/g;
function Me(e, t) {
	for (je.lastIndex = 0;;) {
		var n = je.exec(e);
		if (n) {
			if (n[1] === t) return n[2];
		} else break;
	}
}
function Ne(e) {
	var t = /* @__PURE__ */ new Map();
	for (je.lastIndex = 0;;) {
		var n = je.exec(e);
		if (n) t.set(n[1], n[2]);
		else break;
	}
	return t;
}
function Pe(e, t, n) {
	n === void 0 && (n = "");
	var r = e.charCodeAt(t - 1), i = r >= 55296 && r <= 56319 ? t + 1 : t;
	return e.length <= i ? e : `${e.slice(0, i)}${n}`;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var Fe = 4 * ee, Ie = 15 * h;
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
function Le() {
	return ze() === 1;
}
var Re;
function ze() {
	return Re ??= Be();
}
function Be(e) {
	e === void 0 && (e = window);
	var t = e.navigator.userAgent;
	return e.chrome || /HeadlessChrome/.test(t) ? 1 : e.navigator.vendor?.indexOf("Apple") === 0 || /safari/i.test(t) && !/chrome|android/i.test(t) ? 2 : e.document.documentMode ? 0 : 3;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/browser/cookie.js
function Ve(e, t, n, r) {
	var i = /* @__PURE__ */ new Date();
	i.setTime(i.getTime() + n);
	var a = `expires=${i.toUTCString()}`, o = r && r.crossSite ? "none" : "strict", s = r && r.domain ? `;domain=${r.domain}` : "", c = r && r.secure ? ";secure" : "", l = r && r.partitioned ? ";partitioned" : "";
	document.cookie = `${e}=${t};${a};path=/;samesite=${o}${s}${c}${l}`;
}
function He(e) {
	return Me(document.cookie, e);
}
var Ue;
function j(e) {
	return Ue ||= Ne(document.cookie), Ue.get(e);
}
function We(e, t) {
	Ve(e, "", 0, t);
}
function Ge(e) {
	if (document.cookie === void 0 || document.cookie === null) return !1;
	try {
		var t = `dd_cookie_test_${A()}`, n = "test";
		Ve(t, n, h, e);
		var r = He(t) === n;
		return We(t, e), r;
	} catch (e) {
		return i.error(e), !1;
	}
}
var Ke;
function qe() {
	if (Ke === void 0) {
		for (var e = `dd_site_test_${A()}`, t = "test", n = window.location.hostname.split("."), r = n.pop(); n.length && !He(e);) r = `${n.pop()}.${r}`, Ve(e, t, m, { domain: r });
		We(e, { domain: r }), Ke = r;
	}
	return Ke;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var M = "_dd_s", Je = /^([a-z]+)=([a-z0-9-]+)$/, Ye = "&";
function Xe(e) {
	return ve(e);
}
function Ze(e) {
	e.expire = String(g() + Ie);
}
function Qe(e) {
	return pe(e).map(function(e) {
		return `${e[0]}=${e[1]}`;
	}).join(Ye);
}
function $e(e) {
	var t = {};
	return et(e) && e.split(Ye).forEach(function(e) {
		var n = Je.exec(e);
		if (n !== null) {
			var r = n[1];
			t[r] = n[2];
		}
	}), t;
}
function et(e) {
	return !!e && (e.indexOf(Ye) !== -1 || Je.test(e));
}
var tt = "_dd_r", nt = "_dd_l", rt = "logs";
function it(e) {
	if (!j("_dd_s")) {
		var t = j("_dd"), n = j(tt), r = j(nt), i = {};
		t && (i.id = t), r && /^[01]$/.test(r) && (i[rt] = r), n && /^[012]$/.test(n) && (i.rum = n), Xe(i) || (Ze(i), e.persistSession(i));
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js
function at(e) {
	var t = ut(e);
	return Ge(t) ? {
		type: "Cookie",
		cookieOptions: t
	} : void 0;
}
function ot(e) {
	var t = {
		isLockEnabled: Le(),
		persistSession: st(e),
		retrieveSession: ct,
		clearSession: lt(e)
	};
	return it(t), t;
}
function st(e) {
	return function(t) {
		Ve(M, Qe(t), Ie, e);
	};
}
function ct() {
	return $e(He(M));
}
function lt(e) {
	return function() {
		We(M, e);
	};
}
function ut(e) {
	var t = {};
	return t.secure = !!e.useSecureSessionCookie || !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, t.crossSite = !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, t.partitioned = !!e.usePartitionedCrossSiteSessionCookie, e.trackSessionAcrossSubdomains && (t.domain = qe()), t;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js
var dt = "_dd_test_";
function ft() {
	try {
		var e = A(), t = `${dt}${e}`;
		localStorage.setItem(t, e);
		var n = localStorage.getItem(t);
		return localStorage.removeItem(t), e === n ? { type: "LocalStorage" } : void 0;
	} catch {
		return;
	}
}
function pt() {
	return {
		isLockEnabled: !1,
		persistSession: mt,
		retrieveSession: ht,
		clearSession: gt
	};
}
function mt(e) {
	localStorage.setItem(M, Qe(e));
}
function ht() {
	return $e(localStorage.getItem(M));
}
function gt() {
	localStorage.removeItem(M);
}
var _t = [], vt;
function N(e, t, n) {
	var r;
	n === void 0 && (n = 0);
	var i = t.isLockEnabled, a = t.retrieveSession, o = t.persistSession, s = t.clearSession;
	if (vt ||= e, e !== vt) {
		_t.push(e);
		return;
	}
	if (i && n >= 100) {
		bt(t);
		return;
	}
	var c, l = a();
	if (i) {
		if (l.lock) {
			yt(e, t, n);
			return;
		}
		if (c = A(), l.lock = c, o(l), l = a(), l.lock !== c) {
			yt(e, t, n);
			return;
		}
	}
	var u = e.process(l);
	if (i && (l = a(), l.lock !== c)) {
		yt(e, t, n);
		return;
	}
	if (u && (Xe(u) ? s() : (Ze(u), o(u))), i && !(u && Xe(u))) {
		if (l = a(), l.lock !== c) {
			yt(e, t, n);
			return;
		}
		delete l.lock, o(l), u = l;
	}
	(r = e.after) == null || r.call(e, u || l), bt(t);
}
function yt(e, t, n) {
	D(function() {
		N(e, t, n + 1);
	}, 10);
}
function bt(e) {
	vt = void 0;
	var t = _t.shift();
	t && N(t, e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js
var xt = m;
function St(e) {
	var t = at(e);
	return !t && e.allowFallbackToLocalStorage && (t = ft()), t;
}
function Ct(e, t, n) {
	var r = new O(), i = new O(), a = e.type === "Cookie" ? ot(e.cookieOptions) : pt(), o = a.clearSession, s = a.retrieveSession, c = De(m, xt), l = re(), u = Ae(function() {
		var e;
		N({
			process: function(t) {
				var n = h(t);
				return e = ee(n), n;
			},
			after: function(t) {
				e && !_() && ne(t), l = t;
			}
		}, a);
	}, xt), d = u.throttled, f = u.cancel;
	function p() {
		N({ process: function(e) {
			return _() ? h(e) : void 0;
		} }, a);
	}
	function m() {
		N({
			process: function(e) {
				return ie(e) ? void 0 : {};
			},
			after: h
		}, a);
	}
	function h(e) {
		return ie(e) || (e = {}), _() && (te(e) ? v() : l = e), e;
	}
	function ee(e) {
		var r = n(e[t]), i = r.trackingType, a = r.isTracked;
		return e[t] = i, a && !e.id && (e.id = A(), e.created = String(g())), a;
	}
	function _() {
		return l[t] !== void 0;
	}
	function te(e) {
		return l.id !== e.id || l[t] !== e[t];
	}
	function v() {
		l = {}, i.notify();
	}
	function ne(e) {
		l = e, r.notify();
	}
	function re() {
		var e = s();
		return ie(e) ? e : {};
	}
	function ie(e) {
		return (e.created === void 0 || g() - Number(e.created) < Fe) && (e.expire === void 0 || g() < Number(e.expire));
	}
	return {
		expandOrRenewSession: d,
		expandSession: p,
		getSession: function() {
			return l;
		},
		renewObservable: r,
		expireObservable: i,
		expire: function() {
			f(), o(), h({});
		},
		stop: function() {
			Oe(c);
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var wt = {
	GRANTED: "granted",
	NOT_GRANTED: "not-granted"
};
function Tt(e) {
	var t = new O();
	return {
		tryToInit: function(t) {
			e ||= t;
		},
		update: function(n) {
			e = n, t.notify();
		},
		isGranted: function() {
			return e === wt.GRANTED;
		},
		observable: t
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
function P(e, t, n) {
	if (typeof e != "object" || !e) return JSON.stringify(e);
	var r = F(Object.prototype), i = F(Array.prototype), a = F(Object.getPrototypeOf(e)), o = F(e);
	try {
		return JSON.stringify(e, t, n);
	} catch {
		return "<error: unable to serialize object>";
	} finally {
		r(), i(), a(), o();
	}
}
function F(e) {
	var t = e, n = t.toJSON;
	return n ? (delete t.toJSON, function() {
		t.toJSON = n;
	}) : k;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
function Et(e) {
	return Dt(e, location.href).href;
}
function Dt(e, t) {
	var n = At();
	if (n) try {
		return t === void 0 ? new n(e) : new n(e, t);
	} catch (n) {
		throw Error(`Failed to construct URL: ${String(n)} ${P({
			url: e,
			base: t
		})}`);
	}
	if (t === void 0 && !/:/.test(e)) throw Error(`Invalid URL: '${e}'`);
	var r = document, i = r.createElement("a");
	if (t !== void 0) {
		r = document.implementation.createHTMLDocument("");
		var a = r.createElement("base");
		a.href = t, r.head.appendChild(a), r.body.appendChild(i);
	}
	return i.href = e, i;
}
var Ot = URL, kt;
function At() {
	if (kt === void 0) try {
		kt = new Ot("http://test/path").href === "http://test/path";
	} catch {
		kt = !1;
	}
	return kt ? Ot : void 0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var jt = "datad0g.com", Mt = "datadoghq.com", Nt = "ddog-gov.com", Pt = "pci.browser-intake-datadoghq.com";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js
function I(e, t, n) {
	var r = Ft(e, t);
	return {
		build: function(i, a) {
			return r(Lt(e, t, n, i, a));
		},
		urlPrefix: r(""),
		trackType: t
	};
}
function Ft(e, t) {
	var n = `/api/v2/${t}`, r = e.proxy;
	if (typeof r == "string") {
		var i = Et(r);
		return function(e) {
			return `${i}?ddforward=${encodeURIComponent(`${n}?${e}`)}`;
		};
	}
	if (typeof r == "function") return function(e) {
		return r({
			path: n,
			parameters: e
		});
	};
	var a = It(t, e);
	return function(e) {
		return `https://${a}${n}?${e}`;
	};
}
function It(e, t) {
	var n = t.site, r = n === void 0 ? Mt : n, i = t.internalAnalyticsSubdomain;
	if (e === "logs" && t.usePciIntake && r === "datadoghq.com") return Pt;
	if (i && r === "datadoghq.com") return `${i}.${Mt}`;
	if (r === "dd0g-gov.com") return `http-intake.logs.${r}`;
	var a = r.split("."), o = a.pop();
	return `browser-intake-${a.join("-")}.${o}`;
}
function Lt(e, t, n, r, i) {
	var a = e.clientToken, s = e.internalAnalyticsSubdomain, c = i.retry, u = i.flushReason, d = i.encoding, f = ["sdk_version:5.16.0", `api:${r}`].concat(n);
	u && l(o.COLLECT_FLUSH_REASON) && f.push(`flush_reason:${u}`), c && f.push(`retry_count:${c.count}`, `retry_after:${c.lastFailureStatus}`);
	var p = [
		"ddsource=browser",
		`ddtags=${encodeURIComponent(f.join(","))}`,
		`dd-api-key=${a}`,
		"dd-evp-origin-version=5.16.0",
		"dd-evp-origin=browser",
		`dd-request-id=${A()}`
	];
	return d && p.push(`dd-evp-encoding=${d}`), t === "rum" && p.push(`batch_time=${_()}`), s && p.reverse(), p.join("&");
}
function Rt(e) {
	var t = e.env, n = e.service, r = e.version, i = e.datacenter, a = [];
	return t && a.push(Bt("env", t)), n && a.push(Bt("service", n)), r && a.push(Bt("version", r)), i && a.push(Bt("datacenter", i)), a;
}
var zt = /[^a-z0-9_:./-]/;
function Bt(e, t) {
	var n = 200 - e.length - 1;
	return (t.length > n || zt.test(t)) && i.warn(`${e} value doesn't meet tag requirements and will be sanitized`), `${e}:${t.replace(/,/g, "_")}`;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js
function Vt(e) {
	var t = e.site || "datadoghq.com", n = Rt(e), r = Ht(e, n), i = Wt(r, t);
	return S({
		isIntakeUrl: function(e) {
			return i.some(function(t) {
				return e.indexOf(t) === 0;
			});
		},
		replica: Ut(e, i, n),
		site: t
	}, r);
}
function Ht(e, t) {
	return {
		logsEndpointBuilder: I(e, "logs", t),
		rumEndpointBuilder: I(e, "rum", t),
		sessionReplayEndpointBuilder: I(e, "replay", t)
	};
}
function Ut(e, t, n) {
	if (e.replica) {
		var r = S({}, e, {
			site: Mt,
			clientToken: e.replica.clientToken
		}), i = {
			logsEndpointBuilder: I(r, "logs", n),
			rumEndpointBuilder: I(r, "rum", n)
		};
		return t.push.apply(t, x(i).map(function(e) {
			return e.urlPrefix;
		})), S({ applicationId: e.replica.applicationId }, i);
	}
}
function Wt(e, t) {
	var n = x(e).map(function(e) {
		return e.urlPrefix;
	});
	return t === "datadoghq.com" && n.push(`https://${Pt}/`), n;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js
function Gt(e) {
	if (!e || !e.clientToken) {
		i.error("Client Token is not configured, we will not send any data.");
		return;
	}
	if (e.sessionSampleRate !== void 0 && !f(e.sessionSampleRate)) {
		i.error("Session Sample Rate should be a number between 0 and 100");
		return;
	}
	if (e.telemetrySampleRate !== void 0 && !f(e.telemetrySampleRate)) {
		i.error("Telemetry Sample Rate should be a number between 0 and 100");
		return;
	}
	if (e.telemetryConfigurationSampleRate !== void 0 && !f(e.telemetryConfigurationSampleRate)) {
		i.error("Telemetry Configuration Sample Rate should be a number between 0 and 100");
		return;
	}
	if (e.telemetryUsageSampleRate !== void 0 && !f(e.telemetryUsageSampleRate)) {
		i.error("Telemetry Usage Sample Rate should be a number between 0 and 100");
		return;
	}
	if (e.trackingConsent !== void 0 && !_e(wt, e.trackingConsent)) {
		i.error("Tracking Consent should be either \"granted\" or \"not-granted\"");
		return;
	}
	return Array.isArray(e.enableExperimentalFeatures) && c(e.enableExperimentalFeatures.filter(function(e) {
		return _e(o, e);
	})), S({
		beforeSend: e.beforeSend && a(e.beforeSend, "beforeSend threw an error:"),
		sessionStoreStrategyType: St(e),
		sessionSampleRate: e.sessionSampleRate ?? 100,
		telemetrySampleRate: e.telemetrySampleRate ?? 20,
		telemetryConfigurationSampleRate: e.telemetryConfigurationSampleRate ?? 5,
		telemetryUsageSampleRate: e.telemetryUsageSampleRate ?? 5,
		service: e.service,
		silentMultipleInit: !!e.silentMultipleInit,
		allowUntrustedEvents: !!e.allowUntrustedEvents,
		trackingConsent: e.trackingConsent ?? wt.GRANTED,
		batchBytesLimit: 16 * y,
		eventRateLimiterThreshold: 3e3,
		maxTelemetryEventsPerPage: 15,
		flushTimeout: 30 * m,
		batchMessagesLimit: 50,
		messageBytesLimit: 256 * y
	}, Vt(e));
}
function Kt(e) {
	return {
		session_sample_rate: e.sessionSampleRate,
		telemetry_sample_rate: e.telemetrySampleRate,
		telemetry_configuration_sample_rate: e.telemetryConfigurationSampleRate,
		telemetry_usage_sample_rate: e.telemetryUsageSampleRate,
		use_before_send: !!e.beforeSend,
		use_cross_site_session_cookie: e.useCrossSiteSessionCookie,
		use_partitioned_cross_site_session_cookie: e.usePartitionedCrossSiteSessionCookie,
		use_secure_session_cookie: e.useSecureSessionCookie,
		use_proxy: !!e.proxy,
		silent_multiple_init: e.silentMultipleInit,
		track_session_across_subdomains: e.trackSessionAcrossSubdomains,
		allow_fallback_to_local_storage: !!e.allowFallbackToLocalStorage,
		store_contexts_across_pages: !!e.storeContextsAcrossPages,
		allow_untrusted_events: !!e.allowUntrustedEvents,
		tracking_consent: e.trackingConsent
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
function L(e, t, n) {
	var r = e[t];
	if (typeof r != "function") if (me(t, "on")) r = k;
	else return { stop: k };
	var i = qt(r, n), a = function() {
		if (typeof i == "function") return i.apply(this, arguments);
	};
	return e[t] = a, { stop: function() {
		e[t] === a ? e[t] = r : i = r;
	} };
}
function qt(e, t) {
	return function() {
		var n = de(arguments), r;
		E(t, null, [{
			target: this,
			parameters: n,
			onPostCall: function(e) {
				r = e;
			}
		}]);
		var i = e.apply(this, n);
		return r && E(r, null, [i]), i;
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var R = "?";
function z(e) {
	var t = [], n = on(e, "stack"), r = String(e);
	return n && me(n, r) && (n = n.slice(r.length)), n && n.split("\n").forEach(function(e) {
		var n = Zt(e) || $t(e) || tn(e) || an(e);
		n && (!n.func && n.line && (n.func = R), t.push(n));
	}), {
		message: on(e, "message"),
		name: on(e, "name"),
		stack: t
	};
}
var Jt = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", B = "(?::(\\d+))", Yt = RegExp(`^\\s*at (.*?) ?\\(${Jt}${B}?${B}?\\)?\\s*\$`, "i"), Xt = RegExp(`\\((\\S*)${B}${B}\\)`);
function Zt(e) {
	var t = Yt.exec(e);
	if (t) {
		var n = t[2] && t[2].indexOf("native") === 0, r = t[2] && t[2].indexOf("eval") === 0, i = Xt.exec(t[2]);
		return r && i && (t[2] = i[1], t[3] = i[2], t[4] = i[3]), {
			args: n ? [t[2]] : [],
			column: t[4] ? +t[4] : void 0,
			func: t[1] || R,
			line: t[3] ? +t[3] : void 0,
			url: n ? void 0 : t[2]
		};
	}
}
var Qt = RegExp(`^\\s*at ?${Jt}${B}?${B}??\\s*\$`, "i");
function $t(e) {
	var t = Qt.exec(e);
	if (t) return {
		args: [],
		column: t[3] ? +t[3] : void 0,
		func: R,
		line: t[2] ? +t[2] : void 0,
		url: t[1]
	};
}
var en = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function tn(e) {
	var t = en.exec(e);
	if (t) return {
		args: [],
		column: t[4] ? +t[4] : void 0,
		func: t[1] || R,
		line: +t[3],
		url: t[2]
	};
}
var nn = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, rn = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function an(e) {
	var t = nn.exec(e);
	if (t) {
		var n = t[3] && t[3].indexOf(" > eval") > -1, r = rn.exec(t[3]);
		return n && r && (t[3] = r[1], t[4] = r[2], t[5] = void 0), {
			args: t[2] ? t[2].split(",") : [],
			column: t[5] ? +t[5] : void 0,
			func: t[1] || R,
			line: t[4] ? +t[4] : void 0,
			url: t[3]
		};
	}
}
function on(e, t) {
	if (!(typeof e != "object" || !e || !(t in e))) {
		var n = e[t];
		return typeof n == "string" ? n : void 0;
	}
}
function sn(e, t, n, r) {
	var i = [{
		url: t,
		column: r,
		line: n
	}], a = ln(e);
	return {
		name: a.name,
		message: a.message,
		stack: i
	};
}
var cn = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function ln(e) {
	var t, n, r;
	return {}.toString.call(e) === "[object String]" && (t = cn.exec(e), n = t[1], r = t[2]), {
		name: n,
		message: r
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var un = 220 * y, dn = "$", fn = 3;
function V(e, t) {
	t === void 0 && (t = un);
	var n = F(Object.prototype), r = F(Array.prototype), i = [], a = /* @__PURE__ */ new WeakMap(), o = pn(e, dn, void 0, i, a), s = JSON.stringify(o)?.length || 0;
	if (s > t) {
		_n(t, "discarded", e);
		return;
	}
	for (; i.length > 0 && s < t;) {
		var c = i.shift(), l = 0;
		if (Array.isArray(c.source)) for (var u = 0; u < c.source.length; u++) {
			var d = pn(c.source[u], c.path, u, i, a);
			if (d === void 0 ? s += 4 : s += JSON.stringify(d).length, s += l, l = 1, s > t) {
				_n(t, "truncated", e);
				break;
			}
			c.target[u] = d;
		}
		else for (var u in c.source) if (Object.prototype.hasOwnProperty.call(c.source, u)) {
			var d = pn(c.source[u], c.path, u, i, a);
			if (d !== void 0 && (s += JSON.stringify(d).length + l + u.length + fn, l = 1), s > t) {
				_n(t, "truncated", e);
				break;
			}
			c.target[u] = d;
		}
	}
	return n(), r(), o;
}
function pn(e, t, n, r, i) {
	var a = gn(e);
	if (!a || typeof a != "object") return mn(a);
	var o = hn(a);
	if (o !== "[Object]" && o !== "[Array]" && o !== "[Error]") return o;
	var s = e;
	if (i.has(s)) return `[Reference seen at ${i.get(s)}]`;
	var c = n === void 0 ? t : `${t}.${n}`, l = Array.isArray(a) ? [] : {};
	return i.set(s, c), r.push({
		source: a,
		target: l,
		path: c
	}), l;
}
function mn(e) {
	return typeof e == "bigint" ? `[BigInt] ${e.toString()}` : typeof e == "function" ? `[Function] ${e.name || "unknown"}` : typeof e == "symbol" ? `[Symbol] ${e.description || e.toString()}` : e;
}
function hn(e) {
	try {
		if (e instanceof Event) return { isTrusted: e.isTrusted };
		var t = Object.prototype.toString.call(e).match(/\[object (.*)\]/);
		if (t && t[1]) return `[${t[1]}]`;
	} catch {}
	return "[Unserializable]";
}
function gn(e) {
	var t = e;
	if (t && typeof t.toJSON == "function") try {
		return t.toJSON();
	} catch {}
	return e;
}
function _n(e, t, n) {
	i.warn(`The data provided has been ${t} as it is over the limit of ${e} characters:`, n);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/error/error.js
var vn = "No stack, consider using an instance of Error";
function yn(e) {
	var t = e.stackTrace, n = e.originalError, r = e.handlingStack, i = e.startClocks, a = e.nonErrorPrefix, o = e.source, s = e.handling, c = n instanceof Error, l = bn(t, c, a, n), u = xn(c, t) ? H(t) : vn, d = c ? En(n, o) : void 0;
	return {
		startClocks: i,
		source: o,
		handling: s,
		handlingStack: r,
		originalError: n,
		type: t?.name,
		message: l,
		stack: u,
		causes: d,
		fingerprint: Sn(n)
	};
}
function bn(e, t, n, r) {
	return e?.message && e?.name ? e.message : t ? "Empty message" : `${n} ${P(V(r))}`;
}
function xn(e, t) {
	return t === void 0 ? !1 : e ? !0 : t.stack.length > 0 && (t.stack.length > 1 || t.stack[0].url !== void 0);
}
function Sn(e) {
	return e instanceof Error && "dd_fingerprint" in e ? String(e.dd_fingerprint) : void 0;
}
function H(e) {
	var t = wn(e);
	return e.stack.forEach(function(e) {
		var n = e.func === "?" ? "<anonymous>" : e.func, r = e.args && e.args.length > 0 ? `(${e.args.join(", ")})` : "", i = e.line ? `:${e.line}` : "", a = e.line && e.column ? `:${e.column}` : "";
		t += `
  at ${n}${r} @ ${e.url}${i}${a}`;
	}), t;
}
function Cn(e) {
	return /@ (.+)/.exec(e)?.[1];
}
function wn(e) {
	return `${e.name || "Error"}: ${e.message}`;
}
function Tn() {
	var e = /* @__PURE__ */ Error(), t;
	if (!e.stack) try {
		throw e;
	} catch {}
	return E(function() {
		var n = z(e);
		n.stack = n.stack.slice(2), t = H(n);
	}), t;
}
function En(e, t) {
	for (var n = e, r = []; n?.cause instanceof Error && r.length < 10;) {
		var i = z(n.cause);
		r.push({
			message: n.cause.message,
			source: t,
			type: i?.name,
			stack: i && H(i)
		}), n = n.cause;
	}
	return r.length ? r : void 0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var U = {
	AGENT: "agent",
	CONSOLE: "console",
	CUSTOM: "custom",
	LOGGER: "logger",
	NETWORK: "network",
	SOURCE: "source",
	REPORT: "report"
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js
function Dn(e) {
	var t = function(t, n) {
		var r = yn({
			stackTrace: t,
			originalError: n,
			startClocks: v(),
			nonErrorPrefix: "Uncaught",
			source: U.SOURCE,
			handling: "unhandled"
		});
		e.notify(r);
	}, n = On(t).stop, r = kn(t).stop;
	return { stop: function() {
		n(), r();
	} };
}
function On(e) {
	return L(window, "onerror", function(t) {
		var n = t.parameters, r = n[0], i = n[1], a = n[2], o = n[3], s = n[4];
		e(s instanceof Error ? z(s) : sn(r, i, a, o), s ?? r);
	});
}
function kn(e) {
	return L(window, "onunhandledrejection", function(t) {
		var n = t.parameters[0].reason || "Empty reason";
		e(z(n), n);
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/boot/init.js
function An(e) {
	var t = S({
		version: "5.16.0",
		onReady: function(e) {
			e();
		}
	}, e);
	return Object.defineProperty(t, "_setDebug", {
		get: function() {
			return Ce;
		},
		enumerable: !1
	}), t;
}
function jn(e, t, n) {
	var r = e[t];
	e[t] = n, r && r.q && r.q.forEach(function(e) {
		return a(e, "onReady callback threw an error:")();
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js
function Mn(e, t) {
	t.silentMultipleInit || i.error(`${e} is already initialized.`);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var W;
(function(e) {
	e.BEFORE_UNLOAD = "beforeunload", e.CLICK = "click", e.DBL_CLICK = "dblclick", e.KEY_DOWN = "keydown", e.LOAD = "load", e.POP_STATE = "popstate", e.SCROLL = "scroll", e.TOUCH_START = "touchstart", e.TOUCH_END = "touchend", e.TOUCH_MOVE = "touchmove", e.VISIBILITY_CHANGE = "visibilitychange", e.PAGE_SHOW = "pageshow", e.FREEZE = "freeze", e.RESUME = "resume", e.DOM_CONTENT_LOADED = "DOMContentLoaded", e.POINTER_DOWN = "pointerdown", e.POINTER_UP = "pointerup", e.POINTER_CANCEL = "pointercancel", e.HASH_CHANGE = "hashchange", e.PAGE_HIDE = "pagehide", e.MOUSE_DOWN = "mousedown", e.MOUSE_UP = "mouseup", e.MOUSE_MOVE = "mousemove", e.FOCUS = "focus", e.BLUR = "blur", e.CONTEXT_MENU = "contextmenu", e.RESIZE = "resize", e.CHANGE = "change", e.INPUT = "input", e.PLAY = "play", e.PAUSE = "pause", e.SECURITY_POLICY_VIOLATION = "securitypolicyviolation", e.SELECTION_CHANGE = "selectionchange", e.STORAGE = "storage";
})(W ||= {});
function G(e, t, n, r, i) {
	return Nn(e, t, [n], r, i);
}
function Nn(e, t, n, r, i) {
	var a = i === void 0 ? {} : i, o = a.once, s = a.capture, c = a.passive, l = T(function(t) {
		!t.isTrusted && !t.__ddIsTrusted && !e.allowUntrustedEvents || (o && f(), r(t));
	}), u = c ? {
		capture: s,
		passive: c
	} : s, d = w(t, "addEventListener");
	n.forEach(function(e) {
		return d.call(t, e, l, u);
	});
	function f() {
		var e = w(t, "removeEventListener");
		n.forEach(function(n) {
			return e.call(t, n, l, u);
		});
	}
	return { stop: f };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var K = {
	intervention: "intervention",
	deprecation: "deprecation",
	cspViolation: "csp_violation"
};
function Pn(e, t) {
	var n = [];
	b(t, K.cspViolation) && n.push(In(e));
	var r = t.filter(function(e) {
		return e !== K.cspViolation;
	});
	return r.length && n.push(Fn(r)), ke.apply(void 0, n);
}
function Fn(e) {
	return new O(function(t) {
		if (window.ReportingObserver) {
			var n = T(function(e, n) {
				return e.forEach(function(e) {
					t.notify(Ln(e));
				});
			}), r = new window.ReportingObserver(n, {
				types: e,
				buffered: !0
			});
			return r.observe(), function() {
				r.disconnect();
			};
		}
	});
}
function In(e) {
	return new O(function(t) {
		return G(e, document, W.SECURITY_POLICY_VIOLATION, function(e) {
			t.notify(Rn(e));
		}).stop;
	});
}
function Ln(e) {
	var t = e.type, n = e.body;
	return {
		type: t,
		subtype: n.id,
		message: `${t}: ${n.message}`,
		originalReport: e,
		stack: zn(n.id, n.message, n.sourceFile, n.lineNumber, n.columnNumber)
	};
}
function Rn(e) {
	var t = K.cspViolation, n = `'${e.blockedURI}' blocked by '${e.effectiveDirective}' directive`;
	return {
		type: K.cspViolation,
		subtype: e.effectiveDirective,
		message: `${t}: ${n}`,
		stack: zn(e.effectiveDirective, e.originalPolicy ? `${n} of the policy "${Pe(e.originalPolicy, 100, "...")}"` : "no policy", e.sourceFile, e.lineNumber, e.columnNumber),
		originalReport: e
	};
}
function zn(e, t, n, r, i) {
	return n ? H({
		name: e,
		message: t,
		stack: [{
			func: "?",
			url: n,
			line: r ?? void 0,
			column: i ?? void 0
		}]
	}) : void 0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
function Bn(e, t) {
	var n = window.__ddBrowserSdkExtensionCallback;
	n && n({
		type: e,
		payload: t
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
function Vn(e) {
	return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/mergeInto.js
function Hn(e, t, n) {
	if (n === void 0 && (n = Wn()), t === void 0) return e;
	if (typeof t != "object" || !t) return t;
	if (t instanceof Date) return new Date(t.getTime());
	if (t instanceof RegExp) {
		var r = t.flags || [
			t.global ? "g" : "",
			t.ignoreCase ? "i" : "",
			t.multiline ? "m" : "",
			t.sticky ? "y" : "",
			t.unicode ? "u" : ""
		].join("");
		return new RegExp(t.source, r);
	}
	if (!n.hasAlreadyBeenSeen(t)) {
		if (Array.isArray(t)) {
			for (var i = Array.isArray(e) ? e : [], a = 0; a < t.length; ++a) i[a] = Hn(i[a], t[a], n);
			return i;
		}
		var o = Vn(e) === "object" ? e : {};
		for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (o[s] = Hn(o[s], t[s], n));
		return o;
	}
}
function Un(e) {
	return Hn(void 0, e);
}
function q() {
	for (var e = [...arguments], t, n = 0, r = e; n < r.length; n++) {
		var i = r[n];
		i != null && (t = Hn(t, i));
	}
	return t;
}
function Wn() {
	if (typeof WeakSet < "u") {
		var e = /* @__PURE__ */ new WeakSet();
		return { hasAlreadyBeenSeen: function(t) {
			var n = e.has(t);
			return n || e.add(t), n;
		} };
	}
	var t = [];
	return { hasAlreadyBeenSeen: function(e) {
		var n = t.indexOf(e) >= 0;
		return n || t.push(e), n;
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
function Gn() {
	var e = window.navigator;
	return {
		status: e.onLine ? "connected" : "not_connected",
		interfaces: e.connection && e.connection.type ? [e.connection.type] : void 0,
		effective_type: e.connection?.effectiveType
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var J = {
	log: "log",
	configuration: "configuration",
	usage: "usage"
}, Kn = [
	"https://www.datadoghq-browser-agent.com",
	"https://www.datad0g-browser-agent.com",
	"https://d3uc069fcn7uxw.cloudfront.net",
	"https://d20xtzwzcl0ceb.cloudfront.net",
	"http://localhost",
	"<anonymous>"
], qn = [Nt], Jn = {
	maxEventsPerPage: 0,
	sentEventCount: 0
}, Yn;
function Xn(e, t) {
	var n, r, i = new O(), a = !b(qn, t.site) && d(t.telemetrySampleRate), o = (n = {}, n[J.log] = a, n[J.configuration] = a && d(t.telemetryConfigurationSampleRate), n[J.usage] = a && d(t.telemetryUsageSampleRate), n), s = Zn();
	Yn = function(t) {
		if (o[t.type]) {
			var n = c(e, t, s);
			i.notify(n), Bn("telemetry", n);
		}
	}, Se(er), S(Jn, {
		maxEventsPerPage: t.maxTelemetryEventsPerPage,
		sentEventCount: 0
	});
	function c(e, t, n) {
		return q({
			type: "telemetry",
			date: _(),
			service: e,
			version: "5.16.0",
			source: "browser",
			_dd: { format_version: 2 },
			telemetry: q(t, {
				runtime_env: n,
				connectivity: Gn()
			}),
			experimental_features: de(u())
		}, r === void 0 ? {} : r());
	}
	return {
		setContextProvider: function(e) {
			r = e;
		},
		observable: i,
		enabled: a
	};
}
function Zn() {
	return {
		is_local_file: window.location.protocol === "file:",
		is_worker: "WorkerGlobalScope" in self
	};
}
function Qn(e) {
	return e.site === jt;
}
function $n(t, n) {
	Te(e.debug, t, n), rr(S({
		type: J.log,
		message: t,
		status: "debug"
	}, n));
}
function er(e, t) {
	rr(S({
		type: J.log,
		status: "error"
	}, ir(e), t));
}
function tr(e) {
	rr({
		type: J.configuration,
		configuration: e
	});
}
function nr(e) {
	rr({
		type: J.usage,
		usage: e
	});
}
function rr(e) {
	Yn && Jn.sentEventCount < Jn.maxEventsPerPage && (Jn.sentEventCount += 1, Yn(e));
}
function ir(e) {
	if (e instanceof Error) {
		var t = z(e);
		return {
			error: {
				kind: t.name,
				stack: H(ar(t))
			},
			message: t.message
		};
	}
	return {
		error: { stack: vn },
		message: `Uncaught ${P(e)}`
	};
}
function ar(e) {
	return e.stack = e.stack.filter(function(e) {
		return !e.url || Kn.some(function(t) {
			return me(e.url, t);
		});
	}), e;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js
function or(e) {
	var t = /* @__PURE__ */ new Set();
	return e.forEach(function(e) {
		return t.add(e);
	}), de(t);
}
function sr(e, t) {
	var n = e.indexOf(t);
	n >= 0 && e.splice(n, 1);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/valueHistory.js
var cr = Infinity, lr = h, ur = function() {
	function e(e, t) {
		var n = this;
		this.expireDelay = e, this.maxEntries = t, this.entries = [], this.clearOldValuesInterval = De(function() {
			return n.clearOldValues();
		}, lr);
	}
	return e.prototype.add = function(e, t) {
		var n = this, r = {
			value: e,
			startTime: t,
			endTime: cr,
			remove: function() {
				sr(n.entries, r);
			},
			close: function(e) {
				r.endTime = e;
			}
		};
		return this.maxEntries && this.entries.length >= this.maxEntries && this.entries.pop(), this.entries.unshift(r), r;
	}, e.prototype.find = function(e) {
		e === void 0 && (e = cr);
		for (var t = 0, n = this.entries; t < n.length; t++) {
			var r = n[t];
			if (r.startTime <= e) {
				if (e <= r.endTime) return r.value;
				break;
			}
		}
	}, e.prototype.closeActive = function(e) {
		var t = this.entries[0];
		t && t.endTime === cr && t.close(e);
	}, e.prototype.findAll = function(e, t) {
		e === void 0 && (e = cr), t === void 0 && (t = 0);
		var n = ie(e, t);
		return this.entries.filter(function(t) {
			return t.startTime <= n && e <= t.endTime;
		}).map(function(e) {
			return e.value;
		});
	}, e.prototype.reset = function() {
		this.entries = [];
	}, e.prototype.stop = function() {
		Oe(this.clearOldValuesInterval);
	}, e.prototype.clearOldValues = function() {
		for (var e = te() - this.expireDelay; this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < e;) this.entries.pop();
	}, e;
}(), dr = h, fr = Fe, Y = [];
function pr(e, t, n, r) {
	var i = new O(), a = new O(), o = Ct(e.sessionStoreStrategyType, t, n);
	Y.push(function() {
		return o.stop();
	});
	var s = new ur(fr);
	Y.push(function() {
		return s.stop();
	}), o.renewObservable.subscribe(function() {
		s.add(c(), te()), i.notify();
	}), o.expireObservable.subscribe(function() {
		a.notify(), s.closeActive(te());
	}), o.expandOrRenewSession(), s.add(c(), ne().relative), r.observable.subscribe(function() {
		r.isGranted() ? o.expandOrRenewSession() : o.expire();
	}), mr(e, function() {
		r.isGranted() && o.expandOrRenewSession();
	}), hr(e, function() {
		return o.expandSession();
	});
	function c() {
		return {
			id: o.getSession().id,
			trackingType: o.getSession()[t]
		};
	}
	return {
		findActiveSession: function(e) {
			return s.find(e);
		},
		renewObservable: i,
		expireObservable: a,
		expire: o.expire
	};
}
function mr(e, t) {
	var n = Nn(e, window, [
		W.CLICK,
		W.TOUCH_START,
		W.KEY_DOWN,
		W.SCROLL
	], t, {
		capture: !0,
		passive: !0
	}).stop;
	Y.push(n);
}
function hr(e, t) {
	var n = function() {
		document.visibilityState === "visible" && t();
	}, r = G(e, document, W.VISIBILITY_CHANGE, n).stop;
	Y.push(r);
	var i = De(n, dr);
	Y.push(function() {
		Oe(i);
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
function gr(e) {
	return e >= 500;
}
function _r(e) {
	try {
		return e.clone();
	} catch {
		return;
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js
var vr = 80 * y, yr = 3 * ce, br = h, xr = m;
function Sr(e, t, n, r, i) {
	t.transportStatus === 0 && t.queuedPayloads.size() === 0 && t.bandwidthMonitor.canHandle(e) ? wr(e, t, n, {
		onSuccess: function() {
			return Tr(0, t, n, r, i);
		},
		onFailure: function() {
			t.queuedPayloads.enqueue(e), Cr(t, n, r, i);
		}
	}) : t.queuedPayloads.enqueue(e);
}
function Cr(e, t, n, r) {
	e.transportStatus === 2 && D(function() {
		wr(e.queuedPayloads.first(), e, t, {
			onSuccess: function() {
				e.queuedPayloads.dequeue(), e.currentBackoffTime = xr, Tr(1, e, t, n, r);
			},
			onFailure: function() {
				e.currentBackoffTime = Math.min(br, e.currentBackoffTime * 2), Cr(e, t, n, r);
			}
		});
	}, e.currentBackoffTime);
}
function wr(e, t, n, r) {
	var i = r.onSuccess, a = r.onFailure;
	t.bandwidthMonitor.add(e), n(e, function(n) {
		t.bandwidthMonitor.remove(e), Er(n) ? (t.transportStatus = t.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, e.retry = {
			count: e.retry ? e.retry.count + 1 : 1,
			lastFailureStatus: n.status
		}, a()) : (t.transportStatus = 0, i());
	});
}
function Tr(e, t, n, r, i) {
	e === 0 && t.queuedPayloads.isFull() && !t.queueFullReported && (i({
		message: `Reached max ${r} events size queued for upload: ${yr / ce}MiB`,
		source: U.AGENT,
		startClocks: v()
	}), t.queueFullReported = !0);
	var a = t.queuedPayloads;
	for (t.queuedPayloads = Or(); a.size() > 0;) Sr(a.dequeue(), t, n, r, i);
}
function Er(e) {
	return e.type !== "opaque" && (e.status === 0 && !navigator.onLine || e.status === 408 || e.status === 429 || gr(e.status));
}
function Dr() {
	return {
		transportStatus: 0,
		currentBackoffTime: xr,
		bandwidthMonitor: kr(),
		queuedPayloads: Or(),
		queueFullReported: !1
	};
}
function Or() {
	var e = [];
	return {
		bytesCount: 0,
		enqueue: function(t) {
			this.isFull() || (e.push(t), this.bytesCount += t.bytesCount);
		},
		first: function() {
			return e[0];
		},
		dequeue: function() {
			var t = e.shift();
			return t && (this.bytesCount -= t.bytesCount), t;
		},
		size: function() {
			return e.length;
		},
		isFull: function() {
			return this.bytesCount >= yr;
		}
	};
}
function kr() {
	return {
		ongoingRequestCount: 0,
		ongoingByteCount: 0,
		canHandle: function(e) {
			return this.ongoingRequestCount === 0 || this.ongoingByteCount + e.bytesCount <= vr && this.ongoingRequestCount < 32;
		},
		add: function(e) {
			this.ongoingRequestCount += 1, this.ongoingByteCount += e.bytesCount;
		},
		remove: function(e) {
			--this.ongoingRequestCount, this.ongoingByteCount -= e.bytesCount;
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/httpRequest.js
function Ar(e, t, n, r) {
	var i = Dr(), a = function(r, i) {
		return Pr(e, t, n, r, i);
	};
	return {
		send: function(e) {
			Sr(e, i, a, t.trackType, r);
		},
		sendOnExit: function(r) {
			jr(e, t, n, r);
		}
	};
}
function jr(e, t, n, r) {
	if (navigator.sendBeacon && r.bytesCount < n) try {
		var i = t.build("beacon", r);
		if (navigator.sendBeacon(i, r.data)) return;
	} catch (e) {
		Nr(e);
	}
	Ir(e, t.build("xhr", r), r.data);
}
var Mr = !1;
function Nr(e) {
	Mr || (Mr = !0, er(e));
}
function Pr(e, t, n, r, i) {
	if (Fr() && r.bytesCount < n) {
		var a = t.build("fetch", r);
		fetch(a, {
			method: "POST",
			body: r.data,
			keepalive: !0,
			mode: "cors"
		}).then(T(function(e) {
			return i?.({
				status: e.status,
				type: e.type
			});
		}), T(function() {
			Ir(e, t.build("xhr", r), r.data, i);
		}));
	} else Ir(e, t.build("xhr", r), r.data, i);
}
function Fr() {
	try {
		return window.Request && "keepalive" in new Request("http://a");
	} catch {
		return !1;
	}
}
function Ir(e, t, n, r) {
	var i = new XMLHttpRequest();
	i.open("POST", t, !0), n instanceof Blob && i.setRequestHeader("Content-Type", n.type), G(e, i, "loadend", function() {
		r?.({ status: i.status });
	}, { once: !0 }), i.send(n);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/eventBridge.js
function Lr() {
	var e = zr();
	if (e) return {
		getCapabilities: function() {
			return JSON.parse(e.getCapabilities?.call(e) || "[]");
		},
		getPrivacyLevel: function() {
			return e.getPrivacyLevel?.call(e);
		},
		getAllowedWebViewHosts: function() {
			return JSON.parse(e.getAllowedWebViewHosts());
		},
		send: function(t, n, r) {
			var i = r ? { id: r } : void 0;
			e.send(JSON.stringify({
				eventType: t,
				event: n,
				view: i
			}));
		}
	};
}
function Rr(e) {
	e === void 0 && (e = C().location?.hostname);
	var t = Lr();
	return !!t && t.getAllowedWebViewHosts().some(function(t) {
		return e === t || he(e, `.${t}`);
	});
}
function zr() {
	return C().DatadogEventBridge;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var X = {
	HIDDEN: "visibility_hidden",
	UNLOADING: "before_unload",
	PAGEHIDE: "page_hide",
	FROZEN: "page_frozen"
};
function Br(e) {
	return new O(function(t) {
		var n = l(o.PAGEHIDE), r = Nn(e, window, [
			W.VISIBILITY_CHANGE,
			W.FREEZE,
			W.PAGE_HIDE
		], function(e) {
			e.type === W.PAGE_HIDE && n ? t.notify({ reason: X.PAGEHIDE }) : e.type === W.VISIBILITY_CHANGE && document.visibilityState === "hidden" ? t.notify({ reason: X.HIDDEN }) : e.type === W.FREEZE && t.notify({ reason: X.FROZEN });
		}, { capture: !0 }).stop, i = k;
		return n || (i = G(e, window, W.BEFORE_UNLOAD, function() {
			t.notify({ reason: X.UNLOADING });
		}).stop), function() {
			r(), i();
		};
	});
}
function Vr(e) {
	return b(x(X), e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/batch.js
var Hr = function() {
	function e(e, t, n, r) {
		var i = this;
		this.encoder = e, this.request = t, this.flushController = n, this.messageBytesLimit = r, this.upsertBuffer = {}, this.flushSubscription = this.flushController.flushObservable.subscribe(function(e) {
			return i.flush(e);
		});
	}
	return e.prototype.add = function(e) {
		this.addOrUpdate(e);
	}, e.prototype.upsert = function(e, t) {
		this.addOrUpdate(e, t);
	}, e.prototype.stop = function() {
		this.flushSubscription.unsubscribe();
	}, e.prototype.flush = function(e) {
		var t = x(this.upsertBuffer).join("\n");
		this.upsertBuffer = {};
		var n = Vr(e.reason), r = n ? this.request.sendOnExit : this.request.send;
		if (n && this.encoder.isAsync) {
			var i = this.encoder.finishSync();
			i.outputBytesCount && r(Ur(i, e));
			var a = [i.pendingData, t].filter(Boolean).join("\n");
			a && r({
				data: a,
				bytesCount: ue(a),
				flushReason: e.reason
			});
		} else t && this.encoder.write(this.encoder.isEmpty ? t : `
${t}`), this.encoder.finish(function(t) {
			r(Ur(t, e));
		});
	}, e.prototype.addOrUpdate = function(e, t) {
		var n = P(e), r = this.encoder.estimateEncodedBytesCount(n);
		if (r >= this.messageBytesLimit) {
			i.warn(`Discarded a message whose size was bigger than the maximum allowed size ${this.messageBytesLimit}KB.`);
			return;
		}
		this.hasMessageFor(t) && this.remove(t), this.push(n, r, t);
	}, e.prototype.push = function(e, t, n) {
		var r = this;
		this.flushController.notifyBeforeAddMessage(t), n === void 0 ? this.encoder.write(this.encoder.isEmpty ? e : `
${e}`, function(e) {
			r.flushController.notifyAfterAddMessage(e - t);
		}) : (this.upsertBuffer[n] = e, this.flushController.notifyAfterAddMessage());
	}, e.prototype.remove = function(e) {
		var t = this.upsertBuffer[e];
		delete this.upsertBuffer[e];
		var n = this.encoder.estimateEncodedBytesCount(t);
		this.flushController.notifyAfterRemoveMessage(n);
	}, e.prototype.hasMessageFor = function(e) {
		return e !== void 0 && this.upsertBuffer[e] !== void 0;
	}, e;
}();
function Ur(e, t) {
	return {
		data: typeof e.output == "string" ? e.output : new Blob([e.output], { type: "text/plain" }),
		bytesCount: e.outputBytesCount,
		encoding: e.encoding,
		flushReason: t.reason
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/flushController.js
function Wr(e) {
	var t = e.messagesLimit, n = e.bytesLimit, r = e.durationLimit, i = e.pageExitObservable, a = e.sessionExpireObservable, o = i.subscribe(function(e) {
		return d(e.reason);
	}), s = a.subscribe(function() {
		return d("session_expire");
	}), c = new O(function() {
		return function() {
			o.unsubscribe(), s.unsubscribe();
		};
	}), l = 0, u = 0;
	function d(e) {
		if (u !== 0) {
			var t = u, n = l;
			u = 0, l = 0, m(), c.notify({
				reason: e,
				messagesCount: t,
				bytesCount: n
			});
		}
	}
	var f;
	function p() {
		f === void 0 && (f = D(function() {
			d("duration_limit");
		}, r));
	}
	function m() {
		Ee(f), f = void 0;
	}
	return {
		flushObservable: c,
		get messagesCount() {
			return u;
		},
		notifyBeforeAddMessage: function(e) {
			l + e >= n && d("bytes_limit"), u += 1, l += e, p();
		},
		notifyAfterAddMessage: function(e) {
			e === void 0 && (e = 0), l += e, u >= t ? d("messages_limit") : l >= n && d("bytes_limit");
		},
		notifyAfterRemoveMessage: function(e) {
			l -= e, --u, u === 0 && m();
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js
function Gr(e, t, n, r, i, a) {
	var o = c(e, t), s = n && c(e, n);
	function c(e, t) {
		var n = t.endpoint, o = t.encoder;
		return new Hr(o, Ar(e, n, e.batchBytesLimit, r), Wr({
			messagesLimit: e.batchMessagesLimit,
			bytesLimit: e.batchBytesLimit,
			durationLimit: e.flushTimeout,
			pageExitObservable: i,
			sessionExpireObservable: a
		}), e.messageBytesLimit);
	}
	return {
		flushObservable: o.flushController.flushObservable,
		add: function(e, t) {
			t === void 0 && (t = !0), o.add(e), s && t && s.add(n.transformMessage ? n.transformMessage(e) : e);
		},
		upsert: function(e, t) {
			o.upsert(e, t), s && s.upsert(n.transformMessage ? n.transformMessage(e) : e, t);
		},
		stop: function() {
			o.stop(), s?.stop();
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/encoder.js
function Kr() {
	var e = "", t = 0;
	return {
		isAsync: !1,
		get isEmpty() {
			return !e;
		},
		write: function(n, r) {
			var i = ue(n);
			t += i, e += n, r && r(i);
		},
		finish: function(e) {
			e(this.finishSync());
		},
		finishSync: function() {
			var n = {
				output: e,
				outputBytesCount: t,
				rawBytesCount: t,
				pendingData: ""
			};
			return e = "", t = 0, n;
		},
		estimateEncodedBytesCount: function(e) {
			return e.length;
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var qr = function() {
	function e() {
		this.callbacks = {};
	}
	return e.prototype.notify = function(e, t) {
		var n = this.callbacks[e];
		n && n.forEach(function(e) {
			return e(t);
		});
	}, e.prototype.subscribe = function(e, t) {
		var n = this;
		return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), { unsubscribe: function() {
			n.callbacks[e] = n.callbacks[e].filter(function(e) {
				return t !== e;
			});
		} };
	}, e;
}();
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
function Jr(e, t, n) {
	var r = 0, i = !1;
	return { isLimitReached: function() {
		if (r === 0 && D(function() {
			r = 0;
		}, h), r += 1, r <= t || i) return i = !1, !1;
		if (r === t + 1) {
			i = !0;
			try {
				n({
					message: `Reached max number of ${e}s by minute: ${t}`,
					source: U.AGENT,
					startClocks: v()
				});
			} finally {
				i = !1;
			}
		}
		return !0;
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var Yr, Xr = /* @__PURE__ */ new WeakMap();
function Zr(e) {
	return Yr ||= Qr(e), Yr;
}
function Qr(e) {
	return new O(function(t) {
		var n = L(XMLHttpRequest.prototype, "open", $r).stop, r = L(XMLHttpRequest.prototype, "send", function(n) {
			ei(n, e, t);
		}).stop, i = L(XMLHttpRequest.prototype, "abort", ti).stop;
		return function() {
			n(), r(), i();
		};
	});
}
function $r(e) {
	var t = e.target, n = e.parameters, r = n[0], i = n[1];
	Xr.set(t, {
		state: "open",
		method: String(r).toUpperCase(),
		url: Et(String(i))
	});
}
function ei(e, t, n) {
	var r = e.target, i = Xr.get(r);
	if (i) {
		var a = i;
		a.state = "start", a.startClocks = v(), a.isAborted = !1, a.xhr = r;
		var o = !1, s = L(r, "onreadystatechange", function() {
			r.readyState === XMLHttpRequest.DONE && c();
		}).stop, c = function() {
			if (l(), s(), !o) {
				o = !0;
				var e = i;
				e.state = "complete", e.duration = re(a.startClocks.timeStamp, _()), e.status = r.status, n.notify(ge(e));
			}
		}, l = G(t, r, "loadend", c).stop;
		n.notify(a);
	}
}
function ti(e) {
	var t = e.target, n = Xr.get(t);
	n && (n.isAborted = !0);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var ni;
function ri() {
	return ni ||= ii(), ni;
}
function ii() {
	return new O(function(e) {
		if (window.fetch) return L(window, "fetch", function(t) {
			return ai(t, e);
		}).stop;
	});
}
function ai(e, t) {
	var n = e.parameters, r = e.onPostCall, i = n[0], a = n[1], o = a && a.method;
	o === void 0 && i instanceof Request && (o = i.method);
	var s = o === void 0 ? "GET" : String(o).toUpperCase(), c = i instanceof Request ? i.url : Et(String(i)), l = {
		state: "start",
		init: a,
		input: i,
		method: s,
		startClocks: v(),
		url: c
	};
	t.notify(l), n[0] = l.input, n[1] = l.init, r(function(e) {
		return oi(t, e, l);
	});
}
function oi(e, t, n) {
	var r = function(t) {
		var r = n;
		r.state = "resolve", "stack" in t || t instanceof Error ? (r.status = 0, r.isAborted = t instanceof DOMException && t.code === DOMException.ABORT_ERR, r.error = t) : "status" in t && (r.response = t, r.responseType = t.type, r.status = t.status, r.isAborted = !1), e.notify(r);
	};
	t.then(T(r), T(r));
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var si = {};
function ci(e) {
	var t = e.map(function(e) {
		return si[e] || (si[e] = li(e)), si[e];
	});
	return ke.apply(void 0, t);
}
function li(e) {
	return new O(function(n) {
		var r = t[e];
		return t[e] = function() {
			var t = [...arguments];
			r.apply(console, t);
			var i = Tn();
			E(function() {
				n.notify(ui(t, e, i));
			});
		}, function() {
			t[e] = r;
		};
	});
}
function ui(t, n, r) {
	var i = t.map(function(e) {
		return di(e);
	}).join(" "), a, o, s;
	if (n === e.error) {
		var c = fe(t, function(e) {
			return e instanceof Error;
		});
		a = c ? H(z(c)) : void 0, o = Sn(c), s = c ? En(c, "console") : void 0;
	}
	return {
		api: n,
		message: i,
		stack: a,
		handlingStack: r,
		fingerprint: o,
		causes: s
	};
}
function di(e) {
	return typeof e == "string" ? V(e) : e instanceof Error ? wn(z(e)) : P(V(e), void 0, 2);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var fi = 500, pi = function() {
	function e() {
		this.buffer = [];
	}
	return e.prototype.add = function(e) {
		this.buffer.push(e) > fi && this.buffer.splice(0, 1);
	}, e.prototype.remove = function(e) {
		sr(this.buffer, e);
	}, e.prototype.drain = function(e) {
		this.buffer.forEach(function(t) {
			return t(e);
		}), this.buffer.length = 0;
	}, e;
}();
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
function mi(e) {
	var t = {}, n = new O(), r = {
		getContext: function() {
			return Un(t);
		},
		setContext: function(i) {
			Vn(i) === "object" ? (t = V(i), e.updateCustomerData(t)) : r.clearContext(), n.notify();
		},
		setContextProperty: function(r, i) {
			t[r] = V(i), e.updateCustomerData(t), n.notify();
		},
		removeContextProperty: function(r) {
			delete t[r], e.updateCustomerData(t), n.notify();
		},
		clearContext: function() {
			t = {}, e.resetCustomerData(), n.notify();
		},
		changeObservable: n
	};
	return r;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js
var hi = "_dd_c", gi = [];
function _i(e, t, n, r) {
	var i = vi(n, r);
	gi.push(G(e, window, W.STORAGE, function(e) {
		i === e.key && a();
	})), t.changeObservable.subscribe(o), t.setContext(q(s(), t.getContext()));
	function a() {
		t.setContext(s());
	}
	function o() {
		localStorage.setItem(i, JSON.stringify(t.getContext()));
	}
	function s() {
		var e = localStorage.getItem(i);
		return e === null ? {} : JSON.parse(e);
	}
}
function vi(e, t) {
	return `${hi}_${e}_${t}`;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/context/customerDataTracker.js
var yi = 3 * y, bi = 16 * y;
function xi(e) {
	e === void 0 && (e = 2);
	var t = /* @__PURE__ */ new Map(), n = !1;
	function r(r) {
		if (r === void 0 && (r = 0), !(n || e === 0)) {
			var i = e === 2 ? yi : bi, a = r;
			t.forEach(function(e) {
				a += e.getBytesCount();
			}), a > i && (Ci(i), n = !0);
		}
	}
	return {
		createDetachedTracker: function() {
			var e = Si(function() {
				return r(e.getBytesCount());
			});
			return e;
		},
		getOrCreateTracker: function(e) {
			return t.has(e) || t.set(e, Si(r)), t.get(e);
		},
		setCompressionStatus: function(t) {
			e === 0 && (e = t, r());
		},
		getCompressionStatus: function() {
			return e;
		},
		stop: function() {
			t.forEach(function(e) {
				return e.stop();
			}), t.clear();
		}
	};
}
function Si(e) {
	var t = 0, n = Ae(function(n) {
		t = ue(P(n)), e();
	}, 200), r = n.throttled, i = n.cancel, a = function() {
		i(), t = 0;
	};
	return {
		updateCustomerData: function(e) {
			ve(e) ? a() : r(e);
		},
		resetCustomerData: a,
		getBytesCount: function() {
			return t;
		},
		stop: function() {
			i();
		}
	};
}
function Ci(e) {
	i.warn(`Customer data exceeds the recommended ${e / y}KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning`);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
function wi(e, t, n) {
	var r = e.getReader(), i = [], a = 0;
	o();
	function o() {
		r.read().then(T(function(e) {
			if (e.done) {
				s();
				return;
			}
			n.collectStreamBody && i.push(e.value), a += e.value.length, a > n.bytesLimit ? s() : o();
		}), T(function(e) {
			return t(e);
		}));
	}
	function s() {
		r.cancel().catch(k);
		var e, o;
		if (n.collectStreamBody) {
			var s;
			if (i.length === 1) s = i[0];
			else {
				s = new Uint8Array(a);
				var c = 0;
				i.forEach(function(e) {
					s.set(e, c), c += e.length;
				});
			}
			e = s.slice(0, n.bytesLimit), o = s.length > n.bytesLimit;
		}
		t(void 0, e, o);
	}
}
function Ti() {
	return !!(window._DATADOG_SYNTHETICS_INJECTS_RUM || j("datadog-synthetics-injects-rum"));
}
function Ei() {
	var e = window._DATADOG_SYNTHETICS_PUBLIC_ID || j("datadog-synthetics-public-id");
	return typeof e == "string" ? e : void 0;
}
function Di() {
	var e = window._DATADOG_SYNTHETICS_RESULT_ID || j("datadog-synthetics-result-id");
	return typeof e == "string" ? e : void 0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-core@5.16.0/node_modules/@datadog/browser-core/esm/domain/user/user.js
function Oi(e) {
	var t = S({}, e);
	return [
		"id",
		"name",
		"email"
	].forEach(function(e) {
		e in t && (t[e] = String(t[e]));
	}), t;
}
function ki(e) {
	var t = Vn(e) === "object";
	return t || i.error("Unsupported user:", e), t;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/logger.js
var Ai = function(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}, Z = {
	debug: "debug",
	error: "error",
	info: "info",
	warn: "warn"
}, ji = {
	console: "console",
	http: "http",
	silent: "silent"
}, Mi = Object.keys(Z), Ni = function() {
	function e(e, t, n, r, i, a) {
		r === void 0 && (r = ji.http), i === void 0 && (i = Z.debug), a === void 0 && (a = {}), this.handleLogStrategy = e, this.handlerType = r, this.level = i, this.contextManager = mi(t), this.contextManager.setContext(a), n && this.contextManager.setContextProperty("logger", { name: n });
	}
	return e.prototype.log = function(e, t, n, r) {
		n === void 0 && (n = Z.info);
		var i;
		if (r != null) {
			var a = yn({
				stackTrace: r instanceof Error ? z(r) : void 0,
				originalError: r,
				nonErrorPrefix: "Provided",
				source: U.LOGGER,
				handling: "handled",
				startClocks: v()
			});
			i = {
				stack: a.stack,
				kind: a.type,
				message: a.message,
				causes: a.causes
			};
		}
		var o = V(t), s = i ? q({ error: i }, o) : o;
		this.handleLogStrategy({
			message: V(e),
			context: s,
			status: n
		}, this);
	}, e.prototype.debug = function(e, t, n) {
		this.log(e, t, Z.debug, n);
	}, e.prototype.info = function(e, t, n) {
		this.log(e, t, Z.info, n);
	}, e.prototype.warn = function(e, t, n) {
		this.log(e, t, Z.warn, n);
	}, e.prototype.error = function(e, t, n) {
		this.log(e, t, Z.error, n);
	}, e.prototype.setContext = function(e) {
		this.contextManager.setContext(e);
	}, e.prototype.getContext = function() {
		return this.contextManager.getContext();
	}, e.prototype.setContextProperty = function(e, t) {
		this.contextManager.setContextProperty(e, t);
	}, e.prototype.removeContextProperty = function(e) {
		this.contextManager.removeContextProperty(e);
	}, e.prototype.clearContext = function() {
		this.contextManager.clearContext();
	}, e.prototype.setHandler = function(e) {
		this.handlerType = e;
	}, e.prototype.getHandler = function() {
		return this.handlerType;
	}, e.prototype.setLevel = function(e) {
		this.level = e;
	}, e.prototype.getLevel = function() {
		return this.level;
	}, Ai([we], e.prototype, "log", null), e;
}();
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/contexts/commonContext.js
function Pi(e, t) {
	return {
		view: {
			referrer: document.referrer,
			url: window.location.href
		},
		context: e.getContext(),
		user: t.getContext()
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/configuration.js
var Fi = 32 * y;
function Ii(t) {
	t.usePciIntake === !0 && t.site && t.site !== "datadoghq.com" && i.warn("PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.");
	var n = Gt(t), r = Li(t.forwardConsoleLogs, x(e), "Forward Console Logs"), a = Li(t.forwardReports, x(K), "Forward Reports");
	if (!(!n || !r || !a)) return t.forwardErrorsToLogs && !b(r, e.error) && r.push(e.error), S({
		forwardErrorsToLogs: t.forwardErrorsToLogs !== !1,
		forwardConsoleLogs: r,
		forwardReports: a,
		requestErrorResponseLengthLimit: Fi
	}, n);
}
function Li(e, t, n) {
	if (e === void 0) return [];
	if (!(e === "all" || Array.isArray(e) && e.every(function(e) {
		return b(t, e);
	}))) {
		i.error(`${n} should be "all" or an array with allowed values "${t.join("\", \"")}"`);
		return;
	}
	return e === "all" ? t : or(e);
}
function Ri(e) {
	var t = Kt(e);
	return S({
		forward_errors_to_logs: e.forwardErrorsToLogs,
		forward_console_logs: e.forwardConsoleLogs,
		forward_reports: e.forwardReports,
		use_pci_intake: e.usePciIntake
	}, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/boot/preStartLogs.js
function zi(e, t, n) {
	var r = new pi(), a, o, s = t.observable.subscribe(c);
	function c() {
		if (!(!o || !a || !t.isGranted())) {
			s.unsubscribe();
			var e = n(a, o);
			r.drain(e);
		}
	}
	return {
		init: function(e) {
			if (!e) {
				i.error("Missing configuration");
				return;
			}
			if (Rr() && (e = Bi(e)), a = e, o) {
				Mn("DD_LOGS", e);
				return;
			}
			var n = Ii(e);
			n && (o = n, t.tryToInit(n.trackingConsent), c());
		},
		get initConfiguration() {
			return a;
		},
		getInternalContext: k,
		handleLog: function(t, n, i, a) {
			i === void 0 && (i = e()), a === void 0 && (a = _()), r.add(function(e) {
				return e.handleLog(t, n, i, a);
			});
		}
	};
}
function Bi(e) {
	return S({}, e, { clientToken: "empty" });
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js
var Vi = "logs";
function Hi(e) {
	var t = xi(), n = mi(t.getOrCreateTracker(2)), r = mi(t.getOrCreateTracker(1)), i = Tt();
	function a() {
		return Pi(n, r);
	}
	var o = zi(a, i, function(t, s) {
		t.storeContextsAcrossPages && (_i(s, n, Vi, 2), _i(s, r, Vi, 1));
		var c = e(t, s, a, i);
		return o = Ui(t, c), c;
	}), s = {};
	return An({
		logger: new Ni(function() {
			var e = [...arguments];
			return o.handleLog.apply(o, e);
		}, t.createDetachedTracker()),
		init: T(function(e) {
			return o.init(e);
		}),
		setTrackingConsent: T(function(e) {
			i.update(e), nr({
				feature: "set-tracking-consent",
				tracking_consent: e
			});
		}),
		getGlobalContext: T(function() {
			return n.getContext();
		}),
		setGlobalContext: T(function(e) {
			return n.setContext(e);
		}),
		setGlobalContextProperty: T(function(e, t) {
			return n.setContextProperty(e, t);
		}),
		removeGlobalContextProperty: T(function(e) {
			return n.removeContextProperty(e);
		}),
		clearGlobalContext: T(function() {
			return n.clearContext();
		}),
		createLogger: T(function(e, n) {
			return n === void 0 && (n = {}), s[e] = new Ni(function() {
				var e = [...arguments];
				return o.handleLog.apply(o, e);
			}, t.createDetachedTracker(), V(e), n.handler, n.level, V(n.context)), s[e];
		}),
		getLogger: T(function(e) {
			return s[e];
		}),
		getInitConfiguration: T(function() {
			return Un(o.initConfiguration);
		}),
		getInternalContext: T(function(e) {
			return o.getInternalContext(e);
		}),
		setUser: T(function(e) {
			ki(e) && r.setContext(Oi(e));
		}),
		getUser: T(function() {
			return r.getContext();
		}),
		setUserProperty: T(function(e, t) {
			var n, i = Oi((n = {}, n[e] = t, n))[e];
			r.setContextProperty(e, i);
		}),
		removeUserProperty: T(function(e) {
			return r.removeContextProperty(e);
		}),
		clearUser: T(function() {
			return r.clearContext();
		})
	});
}
function Ui(e, t) {
	return S({
		init: function(e) {
			Mn("DD_LOGS", e);
		},
		initConfiguration: e
	}, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js
var Wi = "logs";
function Gi(e, t) {
	var n = pr(e, Wi, function(t) {
		return Ji(e, t);
	}, t);
	return {
		findTrackedSession: function(e) {
			var t = n.findActiveSession(e);
			return t && t.trackingType === "1" ? { id: t.id } : void 0;
		},
		expireObservable: n.expireObservable
	};
}
function Ki(e) {
	var t = qi(e) === "1" ? {} : void 0;
	return {
		findTrackedSession: function() {
			return t;
		},
		expireObservable: new O()
	};
}
function qi(e) {
	return d(e.sessionSampleRate) ? "1" : "0";
}
function Ji(e, t) {
	var n = Yi(t) ? t : qi(e);
	return {
		trackingType: n,
		isTracked: n === "1"
	};
}
function Yi(e) {
	return e === "0" || e === "1";
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/contexts/rumInternalContext.js
var Xi = !1;
function Zi(e) {
	var t = window;
	if (Ti()) {
		var n = r(t.DD_RUM_SYNTHETICS);
		return !n && !Xi && (Xi = !0, $n("Logs sent before RUM is injected by the synthetics worker", {
			testId: Ei(),
			resultId: Di()
		})), n;
	}
	return r(t.DD_RUM);
	function r(t) {
		if (t && t.getInternalContext) return t.getInternalContext(e);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/assembly.js
function Qi(e, t, n, r, i) {
	var a = Mi.concat(["custom"]), o = {};
	a.forEach(function(e) {
		o[e] = Jr(e, t.eventRateLimiterThreshold, i);
	}), n.subscribe(0, function(i) {
		var a = i.rawLogsEvent, s = i.messageContext, c = s === void 0 ? void 0 : s, l = i.savedCommonContext, u = l === void 0 ? void 0 : l, d = i.domainContext, f = ae(a.date), p = e.findTrackedSession(f);
		if (p) {
			var m = u || r(), h = q({
				service: t.service,
				session_id: p.id,
				usr: ve(m.user) ? void 0 : m.user,
				view: m.view
			}, m.context, Zi(f), a, c);
			t.beforeSend?.call(t, h, d) === !1 || h.origin !== U.AGENT && (o[h.status] ?? o.custom).isLimitReached() || n.notify(1, h);
		}
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var Q, $i = (Q = {}, Q[e.log] = Z.info, Q[e.debug] = Z.debug, Q[e.info] = Z.info, Q[e.warn] = Z.warn, Q[e.error] = Z.error, Q);
function ea(t, n) {
	var r = ci(t.forwardConsoleLogs).subscribe(function(t) {
		n.notify(0, { rawLogsEvent: {
			date: _(),
			message: t.message,
			origin: U.CONSOLE,
			error: t.api === e.error ? {
				stack: t.stack,
				fingerprint: t.fingerprint,
				causes: t.causes
			} : void 0,
			status: $i[t.api]
		} });
	});
	return { stop: function() {
		r.unsubscribe();
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var ta, na = (ta = {}, ta[K.cspViolation] = Z.error, ta[K.intervention] = Z.error, ta[K.deprecation] = Z.warn, ta);
function ra(e, t) {
	var n = Pn(e, e.forwardReports).subscribe(function(e) {
		var n = e.message, r = na[e.type], i;
		r === Z.error ? i = {
			kind: e.subtype,
			stack: e.stack
		} : e.stack && (n += ` Found in ${Cn(e.stack)}`), t.notify(0, { rawLogsEvent: {
			date: _(),
			message: n,
			origin: U.REPORT,
			error: i,
			status: r
		} });
	});
	return { stop: function() {
		n.unsubscribe();
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js
function ia(e, t) {
	if (!e.forwardErrorsToLogs) return { stop: k };
	var n = Zr(e).subscribe(function(e) {
		e.state === "complete" && i("xhr", e);
	}), r = ri().subscribe(function(e) {
		e.state === "resolve" && i("fetch", e);
	});
	function i(n, r) {
		!e.isIntakeUrl(r.url) && (ca(r) || gr(r.status)) && ("xhr" in r ? aa(r.xhr, e, i) : r.response ? sa(r.response, e, i) : r.error && oa(r.error, e, i));
		function i(e) {
			var i = { isAborted: r.isAborted };
			t.notify(0, {
				rawLogsEvent: {
					message: `${ua(n)} error ${r.method} ${r.url}`,
					date: r.startClocks.timeStamp,
					error: { stack: e || "Failed to load" },
					http: {
						method: r.method,
						status_code: r.status,
						url: r.url
					},
					status: Z.error,
					origin: U.NETWORK
				},
				domainContext: i
			});
		}
	}
	return { stop: function() {
		n.unsubscribe(), r.unsubscribe();
	} };
}
function aa(e, t, n) {
	typeof e.response == "string" ? n(la(e.response, t)) : n(e.response);
}
function oa(e, t, n) {
	n(la(H(z(e)), t));
}
function sa(e, t, n) {
	var r = _r(e);
	!r || !r.body ? n() : window.TextDecoder ? da(r.body, t.requestErrorResponseLengthLimit, function(e, t) {
		n(e ? `Unable to retrieve response: ${e}` : t);
	}) : r.text().then(T(function(e) {
		return n(la(e, t));
	}), T(function(e) {
		return n(`Unable to retrieve response: ${e}`);
	}));
}
function ca(e) {
	return e.status === 0 && e.responseType !== "opaque";
}
function la(e, t) {
	return e.length > t.requestErrorResponseLengthLimit ? `${e.substring(0, t.requestErrorResponseLengthLimit)}...` : e;
}
function ua(e) {
	return e === "xhr" ? "XHR" : "Fetch";
}
function da(e, t, n) {
	wi(e, function(e, t, r) {
		if (e) n(e);
		else {
			var i = new TextDecoder().decode(t);
			r && (i += "..."), n(void 0, i);
		}
	}, {
		bytesLimit: t,
		collectStreamBody: !0
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js
function fa(e, t) {
	if (!e.forwardErrorsToLogs) return { stop: k };
	var n = new O(), r = Dn(n).stop, i = n.subscribe(function(e) {
		t.notify(0, { rawLogsEvent: {
			message: e.message,
			date: e.startClocks.timeStamp,
			error: {
				kind: e.type,
				stack: e.stack,
				causes: e.causes
			},
			origin: U.SOURCE,
			status: Z.error
		} });
	});
	return { stop: function() {
		r(), i.unsubscribe();
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js
var pa = qr, $, ma = ($ = {}, $[Z.debug] = 0, $[Z.info] = 1, $[Z.warn] = 2, $[Z.error] = 3, $);
function ha(e) {
	function t(t, n, r, i) {
		var a = q(n.getContext(), t.context);
		ga(t.status, ji.console, n) && _a(t, a), ga(t.status, ji.http, n) && e.notify(0, {
			rawLogsEvent: {
				date: i || _(),
				message: t.message,
				status: t.status,
				origin: U.LOGGER
			},
			messageContext: a,
			savedCommonContext: r
		});
	}
	return { handleLog: t };
}
function ga(e, t, n) {
	var r = n.getHandler(), i = Array.isArray(r) ? r : [r];
	return ma[e] >= ma[n.getLevel()] && b(i, t);
}
function _a(e, r) {
	n[e.status].call(t, e.message, r);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js
function va(e, t, n, r, i) {
	var a = Gr(e, {
		endpoint: e.logsEndpointBuilder,
		encoder: Kr()
	}, e.replica && {
		endpoint: e.replica.logsEndpointBuilder,
		encoder: Kr()
	}, n, r, i.expireObservable);
	return t.subscribe(1, function(e) {
		a.add(e);
	}), a;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js
function ya(e) {
	var t = Lr();
	e.subscribe(1, function(e) {
		t.send("log", e);
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/contexts/internalContext.js
function ba(e) {
	return { get: function(t) {
		var n = e.findTrackedSession(t);
		if (n) return { session_id: n.id };
	} };
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/reportError.js
function xa(e) {
	return function(t) {
		e.notify(0, { rawLogsEvent: {
			message: t.message,
			date: t.startClocks.timeStamp,
			origin: U.AGENT,
			status: Z.error
		} }), $n("Error reported to customer", { "error.message": t.message });
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/domain/logsTelemetry.js
function Sa(e, t, n, r, i) {
	var a = Xn("browser-logs-sdk", t);
	a.setContextProvider(function() {
		return {
			application: { id: Zi()?.application_id },
			session: { id: i.findTrackedSession()?.id },
			view: { id: Zi()?.view?.id },
			action: { id: Zi()?.user_action?.id }
		};
	});
	var o = [];
	if (Rr()) {
		var s = Lr(), c = a.observable.subscribe(function(e) {
			return s.send("internal_telemetry", e);
		});
		o.push(function() {
			return c.unsubscribe();
		});
	} else {
		var l = Gr(t, {
			endpoint: t.rumEndpointBuilder,
			encoder: Kr()
		}, t.replica && {
			endpoint: t.replica.rumEndpointBuilder,
			encoder: Kr()
		}, n, r, i.expireObservable);
		o.push(function() {
			return l.stop();
		});
		var u = a.observable.subscribe(function(e) {
			return l.add(e, Qn(t));
		});
		o.push(function() {
			return u.unsubscribe();
		});
	}
	return tr(Ri(e)), {
		telemetry: a,
		stop: function() {
			o.forEach(function(e) {
				return e();
			});
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/boot/startLogs.js
function Ca(e, t, n, r) {
	var i = new pa(), a = [];
	i.subscribe(1, function(e) {
		return Bn("logs", e);
	});
	var o = xa(i), s = Br(t), c = t.sessionStoreStrategyType && !Rr() && !Ti() ? Gi(t, r) : Ki(t), l = Sa(e, t, o, s, c).stop;
	a.push(function() {
		return l();
	}), ia(t, i), fa(t, i), ea(t, i), ra(t, i);
	var u = ha(i).handleLog;
	if (Qi(c, t, i, n, o), Rr()) ya(i);
	else {
		var d = va(t, i, o, s, c).stop;
		a.push(function() {
			return d();
		});
	}
	return {
		handleLog: u,
		getInternalContext: ba(c).get,
		stop: function() {
			a.forEach(function(e) {
				return e();
			});
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@datadog+browser-logs@5.16.0/node_modules/@datadog/browser-logs/esm/entries/main.js
var wa = Hi(Ca);
jn(C(), "DD_LOGS", wa);
//#endregion
//#region src/main.ts
var Ta = window.DD_LOGS ?? wa, Ea = (e) => (!Ta.getInitConfiguration() && e.enableLogging === "true" && (Ta.init({
	clientToken: e.clientToken,
	site: e.site,
	forwardErrorsToLogs: !0,
	sessionSampleRate: e.sessionSampleRate ?? 100,
	version: e.version,
	env: e.env,
	service: e.service,
	forwardConsoleLogs: ["error", "warn"],
	forwardReports: "all",
	beforeSend: (e) => e.message.startsWith("[MSW]") ? !1 : (e.view.url = e.view.url.replace(/code=[^&]*/, "code=REDACTED"), e.view.referrer && (e.view.referrer = e.view.referrer.replace(/code=[^&]*/, "code=REDACTED")), !0)
}), Ta.setGlobalContextProperty("app", e.app)), Ta);
//#endregion
export { Ta as datadogLogs, Ea as setupLogging };

//# sourceMappingURL=index.js.map